var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "before-close": _vm.handleClose,
        title: _vm.insureType == 13 ? "【投保前提条件告知】" : "投保提醒",
        top: _vm.insureType == 13 ? "10vh" : "16vh",
        visible: _vm.isShow,
        width:
          _vm.insureType == 13 || _vm.insureType == 14 || _vm.insureType == 29
            ? "60%"
            : "45%",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _vm.insureType == 3
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 22 } }, [
                      _c(
                        "table",
                        {
                          staticStyle: { "border-color": "LightGray" },
                          attrs: {
                            border: "1",
                            "border-color": "red",
                            cellpadding: "8",
                            width: "100%",
                          },
                        },
                        [
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [_vm._v("本方案不承保高空作业人员。")]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "本方案第三者责任险不保障第三者的财产损失。"
                              ),
                            ]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "本方案发生的猝死事故，赔偿限额为保单限额的50%。"
                              ),
                            ]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t本方案事故发生后超48小时报案，扣除免赔30%定损。因延迟报案导致无法核定责任和损失的，保险公司不负责赔偿。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t本方案存在不支持销售地区：不承保投保人、被保险人及雇员工作地点属于下述地区的企业：北京市平谷区/密云区/怀柔区、河北省三河市/青龙县/廊坊市、天津市滨海区/静海区、辽宁省铁岭市、山东省禹城/莱州市/滨州市/德州市/临沂市，河南省信阳市/焦作市/新乡市/郏县、四川省宜宾市/雅安市、吉林省四平市、福建省南平下辖、江苏省常州市/连云港市、湖北省黄冈市。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人均已知悉")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 6 && _vm.isFgkGuangfu(_vm.productId)
        ? [
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 22 } }, [
                  _c("span", { staticClass: "u-font-weight-bold u-m-b-5" }, [
                    _vm._v(
                      "\n\t\t\t\t\t以下是该保险产品中免除保险人责任或缩小保障的措辞，烦请投保人确认无误后，方可点击确定投保。\n\t\t\t\t"
                    ),
                  ]),
                  _c("div", { staticStyle: { "white-space": "pre-line" } }, [
                    _vm._v("\n\t\t\t\t\t1、本产品\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v("不承保承揽关系。"),
                    ]),
                    _vm._v("\n\t\t\t\t\t2、本产品\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t不可减人。保险期限1-3个月（含）的保单不可换人。任何保险期限的已出险人员不可替换。\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t\t3、保险事故发生后48小时内报案，因延迟报案导致保险人对无法核实的部分不承担任何赔偿责任。如果\n\t\t\t\t\t"
                    ),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v("被保险人超过72小时才报案"),
                    ]),
                    _vm._v("\n\t\t\t\t\t，则\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。"
                      ),
                    ]),
                    _vm._v("\n\t\t\t\t\t4、\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v("\n\t\t\t\t\t5、\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t被保险人雇员遭受伤害时，实际从事的工作不属于光伏行业工作内容，保险人不承担任何赔偿责任。\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v("\n\t\t\t\t\t6、在\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡，"
                      ),
                    ]),
                    _vm._v("\n\t\t\t\t\t保险人承担赔偿责任，\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v("赔付金额=每人身故赔偿限额*20%。"),
                    ]),
                    _vm._v("\n\t\t\t\t\t7、\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证、电工证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v("\n\t\t\t\t\t8、\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t本产品不认可下列地区的医疗机构发票：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。\n\t\t\t\t\t"
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject("showHint", _vm.productId)
                      },
                    },
                  },
                  [_vm._v("投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人已知悉并同意")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 6
        ? [
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 22 } }, [
                  _c("span", { staticClass: "u-font-weight-bold u-m-b-5" }, [
                    _vm._v(
                      "\n\t\t\t\t\t以下是该保险产品中免除保险人责任或缩小保障的措辞，烦请投保人确认无误后，方可点击确定投保。\n\t\t\t\t"
                    ),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "white-space": "pre-line" } },
                    [
                      _vm._v("\n\t\t\t\t\t1、本产品\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("不承保承揽关系。"),
                      ]),
                      _vm._v("\n\t\t\t\t\t2、本产品\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t不可减人。" +
                            _vm._s(
                              _vm.isFgkCommonYear(_vm.productId)
                                ? ""
                                : "保险期限1-3个月（含）的保单不可换人。"
                            ) +
                            "任何保险期限的已出险人员不可替换。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t3、保险事故发生后48小时内报案，因延迟报案导致保险人对无法核实的部分不承担任何赔偿责任。如果\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("被保险人超过72小时才报案"),
                      ]),
                      _vm._v("\n\t\t\t\t\t，则\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t4、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t如被保险人未有员工出险，则保险人收取保单约定最低保费后，允许保单退保，并退还未满期净保费。最低保费标准：截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t5、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保工种）危险程度高于投保人明确告知保险人的工作类型的，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔20%后赔付。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t6、在\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡，"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t保险人承担赔偿责任，\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("赔付金额=每人身故赔偿限额*20%。"),
                      ]),
                      !_vm.isFgkGang(_vm.productId)
                        ? [
                            _vm._v("\n\t\t\t\t\t\t7、\n\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        : [
                            _vm._v("\n\t\t\t\t\t\t7、\n\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔35%后赔付。\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ],
                      _vm._v("\n\t\t\t\t\t8、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t本产品不认可下列地区的医疗机构发票：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、霸州市、秦皇岛青龙县；湖北黄冈市、麻城市、武穴市、荆州市。\n\t\t\t\t\t"
                        ),
                      ]),
                      !_vm.isFgkGang(_vm.productId)
                        ? [
                            _vm._v("\n\t\t\t\t\t\t9、\n\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t本保单不承保以下工种：水下作业工种、地下作业工种、海上作业工种（渔业、油矿开采等）\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t、矿业/采石业工种、森林防火员、体育运动工种、影视及演艺业工种、战地记者、驯兽师、钢丝绳生产加工、\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t塔吊安装/拆除/维修的工种、铁塔架设/拆除的工种、窑炉/烟囱/高炉新建和拆除的工种\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t、金属冶炼、钢缆生产加工工种、\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("船舶制造/维修/拆除的工种"),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t、化工/军工相关工作工种、涉及火药/炸药/爆破的相关工作工种、保安/保镖/特种兵/军人/武警/公安/警察/消防等治安人员、\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t管道（水下或深度超过1米的地下）/公路/山路/铁路/桥梁/水利/隧道/建筑拆除的工种、钢结构安装或拆除的工种、机械设备拆除工。如施工合同中的项目名称或者作业内容含有保险人不承保的工种字眼，如“桥梁”等，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        : [
                            _vm._v(
                              "\n\t\t\t\t\t\t9、本保单不承保以下工种：\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "水下作业工种、地下作业工种、海上作业工种（渔业、油矿开采等）"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t、矿业/采石业工种、森林防火员、体育运动工种、影视及演艺业工种、战地记者、驯兽师、钢丝绳生产加工、\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t塔吊安装/拆除/维修的工种、铁塔架设/拆除的工种、窑炉/烟囱/高炉新建和拆除的工种\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t、金属冶炼、钢缆生产加工工种、\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("船舶制造/维修/拆除的工种"),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t、化工/军工相关工作工种、涉及火药/炸药/爆破的相关工作工种、保安/保镖/特种兵/军人/武警/公安/警察/消防等治安人员、\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t管道（水下或深度超过1米的地下）/公路/山路/铁路/桥梁/水利/隧道/建筑拆除的工种、钢结构拆除的工种。如施工合同中的项目名称或者作业内容含有保险人不承保的职业类别，如“桥梁”等等，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject("showHint")
                      },
                    },
                  },
                  [_vm._v("投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人已知悉并同意")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 7
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 22 } }, [
                      _c(
                        "table",
                        {
                          staticStyle: { "border-color": "LightGray" },
                          attrs: {
                            border: "1",
                            "border-color": "red",
                            cellpadding: "8",
                            width: "100%",
                          },
                        },
                        [
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [_vm._v("本方案不保障第三者赔偿责任")]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "投保本方案后，从事高处作业时，因未系挂安全带导致的死亡事故，须免赔10%"
                              ),
                            ]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [_vm._v("本方案不支持人员变更和新增")]),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人均已知悉")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 17
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 22 } }, [
                      _c(
                        "table",
                        {
                          staticStyle: { "border-color": "LightGray" },
                          attrs: {
                            border: "1",
                            "border-color": "red",
                            cellpadding: "8",
                            width: "100%",
                          },
                        },
                        [
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "非工作原因导致的个人意外，不属于保障范围"
                              ),
                            ]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "每次事故财产损失免赔1000元或损失金额的10%，以高者为准"
                              ),
                            ]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "工单机器的损失及特定财产，不属于保障范围"
                              ),
                            ]),
                          ]),
                          _c("tr", { staticStyle: { "font-weight": "bold" } }, [
                            _c("td", [
                              _vm._v(
                                "在保人员离开用户家后发生或发现第三者意外事故，不属于保障范围"
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人均已知悉")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 8
        ? [
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 22 } }, [
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t以下是该保险产品\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red" }, [_vm._v("拒绝承保")]),
                    _vm._v(
                      "\n\t\t\t\t\t的职业，请确认投保的雇员中，是否有人从事如下职业？\n\t\t\t\t"
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 22 } }, [
                  _c(
                    "table",
                    {
                      staticStyle: { "border-color": "LightGray" },
                      attrs: {
                        border: "1",
                        "border-color": "red",
                        cellpadding: "8",
                        width: "100%",
                      },
                    },
                    [
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t农牧渔业、海上作业、\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("地质矿产业、化工"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t/军工制造业、影视及演艺业\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v("\n\t\t\t\t\t\t\t建筑物\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("外墙维护"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t及\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("玻璃幕墙安装维护"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t人员、\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("桥梁/隧道"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t工程人员\n\t\t\t\t\t\t"),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "凿岩工、防水工、水运工程施工、水坝工程人员、潜水工作人员"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [_vm._v("体育运动、各种杂技人员、驯兽师")]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t涉及火药/炸药/爆破的相关工作、\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("易燃易爆/危险化学品"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t运输司机及随车工\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v("特种兵/军人/武警/公安/警察/消防等治安人员"),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("高压电"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t工作人员、快递/外卖配送\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject("showHint")
                      },
                    },
                  },
                  [_vm._v("有")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("没有")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 10
        ? [
            _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
              _c("p", [
                _vm._v(
                  "本保单仅承保电梯和商业中央空调的安装、维护和运营，不承保电梯井道施工以及其他任何形式的施工、地暖作业等。"
                ),
              ]),
            ]),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("我已知悉并确认投保")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 9
        ? [
            _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
              _c("p", [
                _vm._v(
                  "\n\t\t\t\t为了保障您的权益，您在投保流程页面的操作将被完整记录。请您仔细阅读保险条款，填写真实有效的信息，重点关注保险责任、责任免除、被保险人权力义务、免赔额或免赔率的计算、退保损失等内容。如有疑问，可查看本产品相关的疑问解答，或致电要求对上述内进行详细讲解。\n\t\t\t"
                ),
              ]),
            ]),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("我已知悉并确认投保")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 11
        ? [
            _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
              _c("p", [
                _vm._v("该方案出单后期新增人员需工作日线下申请，请知悉。"),
              ]),
            ]),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("我已知悉并确认投保")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 12
        ? [
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c("div", { staticClass: "u-m-b-15 u-font-weight-bold" }, [
                    _vm._v(
                      "\n\t\t\t\t\t以下是该保险产品中免除保险人责任或缩小保障的措辞，烦请投保人确认无误后，方可点击确定投保。\n\t\t\t\t"
                    ),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { "white-space": "pre-line" } },
                    [
                      _vm._v("\n\t\t\t\t\t1、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t本产品不承保实际经营地址在以下地区的单位：青海省、新疆维吾尔自治区、西藏自治区、四川省甘孜藏族自治州，阿坝藏族羌族自治州、凉山彝族自治州、天津市、山东省临沂市。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t2、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t本产品不可减人。保险期限1-3个月（含）的保单不可换人。任何保险期限的已出险人员不可替换。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t3、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t保险事故发生后48小时内报案，因延迟报案导致保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t4、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t本保单指定就诊医院为大陆境内二级及以上公立医院。对于前往非本保单指定就诊医院所产生的医疗费用，保险人对按保单约定的应承担的保险责任，免赔20%。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm.isAnZeGang(_vm.productId)
                        ? [
                            _vm._v("\n\t\t\t\t\t\t5、\n\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t从事高处作业必须取得有效高处作业证且佩戴安全带，否则发生身故或伤残事故，保险人对按保单约定的应承担的保险责任免赔35%。保险人对其他特种作业人员（除高处作业）无要求持有特种作业操作证。高处作业证必须由应急管理部门颁发。\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        : [
                            _vm._v("\n\t\t\t\t\t\t5、\n\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t从事高处作业必须取得有效高处作业证且佩戴安全带，否则发生身故或伤残事故，保险人对按保单约定的应承担的保险责任免赔25%。保险人对其他特种作业人员（除高处作业）无要求持有特种作业操作证。高处作业证必须由应急管理部门颁发\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ],
                      _vm._v("\n\t\t\t\t\t6、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t被保险人雇员遭受伤害时，实际从事的工作（不属于拒绝承保职业）危险程度高于投保职业或营业范围的，则保险人对按保单约定的应承担的保险责任，免赔30%。如属于拒绝承保职业，保险人不承担任何赔偿责任。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t7、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t以下四种情况均不属于保险责任。\n\t\t\t\t\t\t（1）被保险人或其代表、雇用人员使用机动车辆造成第三者人身伤亡或财产损失的赔偿责任；\n\t\t\t\t\t\t（2）各种职业病、疾病、中暑、猝死等非意外事故； （3）被保险人及其雇员、第三者的财产损失；\n\t\t\t\t\t\t（4）雇员在上下班途中，受到的交通及意外事故伤害；\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t8、若投保标准版，本产品的雇员及第三者均按《\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("人体损伤致残程度分级"),
                      ]),
                      _vm._v("\n\t\t\t\t\t》（\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("2017年1月1日起施行版本"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t）确定伤残等级而支付相应赔偿金。\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t一级100%，二级90%，三级80%，四级70%，五级60%，六级30%，七级20%，八级15%，九级7%，十级5%。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t9、若投保工标版，本产品\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("被保险人雇员"),
                      ]),
                      _vm._v("\n\t\t\t\t\t按《\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("劳动能力鉴定职工工伤与职业病致残等级"),
                      ]),
                      _vm._v("\n\t\t\t\t\t》确定伤残等级。\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("第三者"),
                      ]),
                      _vm._v("\n\t\t\t\t\t《\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("人体损伤致残程度分级"),
                      ]),
                      _vm._v("\n\t\t\t\t\t》（\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("2017年1月1日起施行版本"),
                      ]),
                      _vm._v("\n\t\t\t\t\t）确定伤残等级。均\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t按一级100%，二级90%，三级80%，四级70%，五级60%，六级30%，七级20%，八级15%，九级7%，十级5%。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t10、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t被保险人雇员仅需门诊治疗的，按本保单约定无误工费赔付。本保单误工费赔付仅适用被保险人雇员，第三者无误工费赔付。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t11、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t本保单累计死亡人数2人（含）及以上的，须提供安监证明，否则保险人有权不承担赔偿责任。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm.isAnZeGang(_vm.productId)
                        ? [
                            _vm._v(
                              "\n\t\t\t\t\t\t12、本保单拒绝承保职业：\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t地下（露天打桩和挖地基除外）/水下/水上作业、渔业、船舶相关工作、邮政/快递/航空/水上运输业、地质矿产/石油/天然气/采石业、凿岩工、森林砍伐/防火人员、驯兽师、动物饲养、塔吊安装拆除和维修、窑炉/烟囱新建和拆除、高炉炉前/运转工人、钢缆生产加工、钢丝绳生产加工、石棉制造、水泥制造、化工/军工/火工相关工作、水电工（地下）、涉及危险品/有毒物品/防化器/烟花爆竹/火药/炸药/枪炮/爆破的相关工作、保镖、特种兵/军人/武警/公安/警察/消防等治安人员、警校/军校、体育运动、记者、演艺/娱乐业、各式垃圾处理场的场主和操作人员（包括但不限于垃圾堆、焚烧厂和有毒废物处理厂的承包商）、家具行业、楼宇拆除、桥隧工人。\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        : [
                            _vm._v(
                              "\n\t\t\t\t\t\t12、本保单拒绝承保职业：\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t地下（露天打桩和挖地基除外）/水下/水上作业、渔业、船舶相关工作、邮政/快递/航空/水上运输业、地质矿产/石油/天然气/采石业、凿岩工、森林砍伐/防火人员、驯兽师、动物饲养、塔吊安装拆除和维修、窑炉/烟囱新建和拆除、高炉炉前/运转工人、钢缆生产加工、钢丝绳生产加工、石棉制造、水泥制造、化工/军工/火工相关工作、水电工（地下）、涉及危险品/有毒物品/防化器/烟花爆竹/火药/炸药/枪炮/爆破的相关工作、保镖、特种兵/军人/武警/公安/警察/消防等治安人员、警校/军校、体育运动、记者、演艺/娱乐业、各式垃圾处理场的场主和操作人员（包括但不限于垃圾堆、焚烧厂和有毒废物处理厂的承包商）、家具行业、楼宇拆除、桥隧工人、钢结构安装工/钢骨结构工人/钢架架设工人。\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject("showHint")
                      },
                    },
                  },
                  [_vm._v("有")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("没有")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.isGetMeiyaB
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t  投保本保险前，投保人应如实告知本保险以下投保前提条件有关的情况，确认符合下列所有投保前提条件方可进行投保，若保险合同订立后发现不符合下列任何投保前提条件的，则视为投保人故意未依法履行如实告知义务。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  1.投保人不属于以下保险公司不接受投保的行业之一：渔业、森林砍伐业、矿业采石业、航运业以及涉及隧道作业、地下作业、山洞作业、水上作业、易燃易爆物品生产和运输、武器弹药研究和开发、驯兽及凶猛动物养殖的职业活动的企业。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  2.任何提出投保申请的人员或在保险期间内提出参保申请的人员均符合本保险约定的团体成员资格。本保险约定的团体成员资格须同时满足以下要求：\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  (1)属于投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "blue" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期雇用的情形。约定的团体成员投保年龄限制：18-65周岁。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  (2)属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  3.投保人未曾被任何保险公司拒绝投保申请，未曾被任何保险公司拒绝保险合同续保，未曾被任何保险公司解除保险合同，且未曾被任何保险公司要求加费或附加特别约定方可承保。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  4.投保人（包括子公司和分支机构）在下列这些国家或地区中不存在风险*：古巴、伊朗、叙利亚、朝鲜、乌克兰克里米亚地区、卢甘斯克、顿涅茨克\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [_vm._v("  * “风险”是指下列任一情形：")]),
                      _c("div", [
                        _vm._v(
                          "  i. 投保人的注册地、住所地或运营地位于上述任何国家或地区。"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  ii.\n\t\t\t\t\t\t投保人所从事的业务活动（例如：服务、货运、销售、供应渠道、投保财产）涉及上述任何国家或地区。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  iii.\n\t\t\t\t\t\t投保人的董事会成员或高级管理人员住所地在上述任何国家或地区，或者投保人的大股东（包括个人或者实体）的注册地、住所地或居住地在上述任何国家或地区。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  对于上述任何一项投保前提条件，如投保人未进行确认的，则保险公司不接受投保人投保本保险的申请；对于上述第2项投保前提条件，如本保险投保时投保人确认符合该项投保前提条件，但任何投保人员在保险合同订立后或在保险合同有效期内发现不符合的，则\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "blue" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("我不同意")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count == 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("我同意")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.isGetMeiyaC
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t  投保本保险前，投保人应如实告知本保险以下投保前提条件有关的情况，确认符合下列所有投保前提条件方可进行投保，若保险合同订立后发现不符合下列任何投保前提条件的，则视为投保人故意未依法履行如实告知义务。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  1.投保人不属于以下保险公司不接受投保的行业之一：渔业、森林砍伐业、矿业采石业、航运业以及涉及隧道作业、地下作业、山洞作业、水上作业、易燃易爆物品生产和运输、武器弹药研究和开发、驯兽及凶猛动物养殖的职业活动的企业，以及提供人力资源服务的人力资源、劳务派遣公司及其他人力资源中介公司。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  2.任何提出投保申请的人员或在保险期间内提出参保申请的人员均符合本保险约定的投保资格。\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "blue" }, [
                          _vm._v(
                            "本保险约定的投保资格指投保或参保人员须同时满足以下要求："
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "blue" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t  （1）属于投保人所申报的符合所有投保条件的其于中国大陆境内直接雇佣的属于本保险接受投保职业类别的在岗全职雇员，但不包括任何国家或国际组织认定的恐怖分子或恐怖组织成员，或非法从事毒品、核武器、生物或化学武器交易人员。前述雇员参保时的年龄限制：18-65周岁。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", { staticClass: "blue" }, [
                        _vm._v("  为明确起见，相关定义约定如下："),
                      ]),
                      _c("div", { staticClass: "blue" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t  1）本保险所称的投保行业不包括任何提供人力资源服务的人力资源、劳务派遣公司及其他人力资源中介。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", { staticClass: "blue" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t  2）本保险所称的“直接雇佣”是指投保人与其所申报的人员直接订立书面劳动合同或其他书面形式的用工合同，且该人员直接为投保人工作，并由投保人直接给付工资或报酬的情形，包括投保人短期劳动用工的情形。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", { staticClass: "blue" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t  3）本保险所称的“在岗全职雇员”须在与投保人存在劳动用工关系期间，不存在除投保人之外的其他用人单位或用工主体。为避免歧义，在岗全职雇员不包括与投保人存在劳动用工关系的非全职临时工、小时工、兼职实习生等非全职雇员以及培训学员、会员等不具备劳动用工关系的人员。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  (2)属于中国大陆境内（不含香港、澳门、台湾）常住，且身体健康、能正常工作和正常生活的被保险人，中国大陆境内常住是指被保险人参保时的前一个自然年度内在中国大陆境内的居住时间累计达到或超过183天。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  3.投保人未曾被任何保险公司拒绝投保申请，未曾被任何保险公司拒绝保险合同续保，未曾被任何保险公司解除保险合同，且未曾被任何保险公司要求加费或附加特别约定方可承保。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  4.投保人（包括子公司和分支机构）在下列这些国家或地区中不存在风险*：古巴、伊朗、叙利亚、朝鲜、乌克兰克里米亚地区、卢甘斯克、顿涅茨克\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [_vm._v("  * “风险”是指下列任一情形：")]),
                      _c("div", [
                        _vm._v(
                          "  i. 投保人的注册地、住所地或运营地位于上述任何国家或地区。"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  ii.\n\t\t\t\t\t\t投保人所从事的业务活动（例如：服务、货运、销售、供应渠道、投保财产）涉及上述任何国家或地区。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  iii.\n\t\t\t\t\t\t投保人的董事会成员或高级管理人员住所地在上述任何国家或地区，或者投保人的大股东（包括个人或者实体）的注册地、住所地或居住地在上述任何国家或地区。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "blue",
                          staticStyle: { "margin-top": "10px" },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t  对于上述任何一项投保前提条件，如投保人未进行确认的，则保险公司不接受投保人投保本保险的申请；对于上述第2项投保前提条件，如本保险投保时投保人确认符合该项投保前提条件，但任何投保或参保人员在保险合同订立后或在保险合同有效期内发现不符合的，则保险公司有权依据合同约定取消该人员的被保资格，并对于取消其被保资格前所发生的保险事故不承担任何保险责任。\n\t\t\t\t\t"
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人均已知悉")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 15
        ? [
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 22 } }, [
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t以下是该保险产品\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red" }, [_vm._v("拒绝承保")]),
                    _vm._v(
                      "\n\t\t\t\t\t的职业，请确认投保的雇员中，是否有人从事如下职业？\n\t\t\t\t"
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 22 } }, [
                  _c(
                    "table",
                    {
                      staticStyle: { "border-color": "LightGray" },
                      attrs: {
                        border: "1",
                        "border-color": "red",
                        cellpadding: "8",
                        width: "100%",
                      },
                    },
                    [
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t农畜渔牧业/木材森林业/矿业采石业/\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("交通运输业"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t/\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("建筑工程业（不含室内项目）"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t/职业运动员/娱乐业/\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v("\n\t\t\t\t\t\t\t公共事业/\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("家用空调安装"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t/\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("电梯行业"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t/军人/金属冶炼/\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("高压电相关职业"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t/水泥石膏石灰行业\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "化工制造行业/火药、炸药、烟花业/邮政/快递、窑炉/烟囱建设及拆除、石油天然气开发"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t危险品/危化品、\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "blue" }, [
                            _vm._v("家具/家私业"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t、船舶/造船业\n\t\t\t\t\t\t"),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject("showHint")
                      },
                    },
                  },
                  [_vm._v("有")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("没有")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 14
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t  根据保险法要求，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t对保险合同中免除保险人责任的条款，保险人在订立合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明，\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t以下是该保险产品中免除保险人责任或缩小保障的措辞，烦请投保人确认无误后，方可点击确定投保。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t  1.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v("被保险人必须在保险事故发生后48小时内报案"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t，因延迟报案影响保险人查勘、定损的，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t保险人对无法核实的部分不承担任何赔偿责任。如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，免赔50%\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t。\n\t\t\t\t\t"),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t  2.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "若出险时为交通事故，索赔时须提供公安部门出具的证明"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t（列明当事人、出险时间、地点、原因及经过等事故信息）\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v("或交警部门出具的事故责任认定书"),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t，发生交通事故\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "需先行车险理赔，若上述材料未提供或提供信息不完整的案件，保险人有权予以拒赔"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t。\n\t\t\t\t\t"),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t  3.出险时，\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t若车辆载物大于核定载质量50%以上的，保险人对按保单规定的应承担的保险责任，免赔50%；若车辆载物大于核定载质量30%以上未达50%，保险人对按保单规定的应承担的保险责任，免赔30%\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t。\n\t\t\t\t\t"),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t  4.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保单不承担车辆及车上任何货物损失，不承担由于职业病或任何性质的精神损害赔偿责任。不承保装卸工与不承担车上人员装卸作业事故责任。\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t  5.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "车辆驾驶员或操作员需持国家有关部门核发的有效操作证"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t，否则\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "保险人对按保单规定的应承担的保险责任，免赔20%"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t，若\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v("车辆驾驶员驾驶证无效或车辆行驶证无效"),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t，则\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v("保险人不承担保险责任"),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t。\n\t\t\t\t\t"),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  6.高处作业以《高处作业分级标准》（中华人民共和国国家标准GB3608-2008）中的定义为准。\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t从事高处作业须系安全带，且须持有有效的特种作业操作证（高处作业），否则保险人对按保单规定的应承担的保险责任，免赔20%\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t。\n\t\t\t\t\t"),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t  7.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "本保单指定就诊医院为大陆境内二级及以上公立医院"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t，但\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t不包括以下地区的医疗机构：天津静海区、滨海新区；河北省沧州市、廊坊市、三河市、秦皇岛青龙县；湖北黄冈市、麻城市、荆州市\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t。如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v("\n\t\t\t\t\t\t。\n\t\t\t\t\t"),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t  8.（若扩展猝死责任）在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t），保险人承担赔偿责任。\n\t\t\t\t\t"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("我不同意")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("我同意")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 16
        ? [
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 22 } }, [
                  _c("p", [
                    _vm._v(
                      "\n\t\t\t\t\t本产品仅承保建筑相关行业，\n\t\t\t\t\t"
                    ),
                    _c("span", { staticClass: "red" }, [
                      _vm._v("1-3类职业不保高空作业，4-6类职业可保高空作业"),
                    ]),
                    _vm._v("\n\t\t\t\t\t，以下是该保险产品\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red" }, [_vm._v("拒绝承保")]),
                    _vm._v(
                      "\n\t\t\t\t\t的职业，请确认投保的雇员中，是否有人从事如下职业？\n\t\t\t\t"
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { justify: "center", type: "flex" } },
              [
                _c("el-col", { attrs: { span: 22 } }, [
                  _c(
                    "table",
                    {
                      staticStyle: { "border-color": "LightGray" },
                      attrs: {
                        border: "1",
                        "border-color": "red",
                        cellpadding: "8",
                        width: "100%",
                      },
                    },
                    [
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "地下作业、塔吊安装拆除和维修、铁塔架设和拆除、窑炉/烟囱新建和拆除"
                          ),
                        ]),
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            "钢结构、钢骨结构、涉及火药/炸药/爆破的相关工作和建筑拆除"
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject("showHint")
                      },
                    },
                  },
                  [_vm._v("有")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("没有")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 18
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t  根据保险法要求，对保险合同中免除保险人责任的条款，保险人在订立合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明， 以下是\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v("该保险产品中免除保险人责任或缩小保障"),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t的特约，烦请与投/被保险人确认，并取得投/被保险人的同意后，方可投保。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t1.本保单的雇员误工费，经医院证明，对于超过五天期间的误工损失按100元/天的标准赔偿误工费用，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "赔偿公式为：100x(实际暂时丧失工作能力天数 - 5天)"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t，每次不超过90天，累计不超过180天。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t2.本保单猝死\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v("赔偿限额为每人每次死亡伤残赔偿限额的20%。"),
                        ]),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t3.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保单需在48小时内及时报案，未及时报案导致保险人对无法确定的部分，不承担赔偿保险金的责任。\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t4.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t对于进行电梯井道与结构作业的安装工人，本保单只承保其在进行电梯施工工作发生的保险事故，\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t进行其他施工过程中发生的保险事故为除外责任。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t5.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t出险索赔时，对于电梯维修人员，需提供电梯操作证，对于电梯安装工人，需提供岗前培训通过证明文件，否则保险人有权拒绝赔偿。\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _vm._v("\n\t\t\t\t\t\t6.\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t北京平谷区密云区、河北省承德市兴隆县中医院、河北省三河市、天津滨海区静海区、辽宁铁岭、河北青龙县、廊坊市、山东禹城、河南信阳下辖的各医疗机构\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t，不在保险公司认可医院范围内。\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "6、即上述地区医疗机构的发票保险公司不予理赔。"
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\t\t7.从事高空作业人员，必须定期进行身体检查，被保险人的雇员无妨碍从事相应特种作业的器质性心脏病、癫痫病、美尼尔氏症、眩晕症、癔病、震颤麻痹症、精神病、痴呆症以及其它不适应高空作业的人，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t不得从事高空作业；从事高空作业必须配带安全带、安全帽、孔洞须加强围栏或防滑措施，如存在前述疾病或未遵守签署高空作业防范措施，保险公司有权拒绝赔付。\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t已知悉，我已告知投/被保险人，并取得投/被保险人的同意\n\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 19
        ? [
            _c("div", { staticStyle: { "line-height": "24px" } }, [
              _vm._v("\n\t\t\t本保单仅承保制造相关行业。\n\t\t\t"),
              _c("br"),
              _vm._v("\n\t\t\t被保险人从业人员的年龄限\n\t\t\t"),
              _c("span", { staticClass: "red-bold" }, [_vm._v("16-65周岁")]),
              _vm._v("\n\t\t\t，本方案每人\n\t\t\t"),
              _c("span", { staticClass: "red-bold" }, [
                _vm._v("限投1份，超过部分无效。"),
              ]),
              _c("br"),
              _vm._v(
                "\n\t\t\t鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。\n\t\t\t"
              ),
              _c("span", { staticClass: "red-bold" }, [
                _vm._v("在保单生效后申请退保或批减在保人员的，可退保费为0。"),
              ]),
              _c("br"),
              _c("span", { staticClass: "red-bold" }, [
                _vm._v(
                  "\n\t\t\t\t从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证）\n\t\t\t"
                ),
              ]),
              _vm._v(
                "\n\t\t\t，否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，\n\t\t\t"
              ),
              _c("span", { staticClass: "red-bold" }, [_vm._v("免赔25%。")]),
              _c("br"),
              _c("span", { staticClass: "red-bold" }, [
                _vm._v(
                  "\n\t\t\t\t本保单不承保职业：船舶制造人员\n\t\t\t\t、玻璃、陶瓷、搪瓷制造业人员、涉及爆破的相关工作人员，如作业内容含有保险人不承保的职业类别，保险人不承担任何赔偿责任。\n\t\t\t"
                ),
              ]),
            ]),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject("showHint")
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count == 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t已知悉，我已告知投/被保险人，并取得投/被保险人的同意\n\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 21
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "u-m-b-15 u-font-weight-bold" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t根据保险法要求，\n\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t对保险合同中免除保险人责任的条款，保险人在订立合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明，\n\t\t\t\t\t\t"
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "\n\t\t\t\t\t\t以下是该保险产品中免除保险人责任或缩小保障的措辞，烦请投保人确认无误后，方可点击确定投保。\n\t\t\t\t\t"
                          ),
                        ]
                      ),
                      _vm._v("\n\n\t\t\t\t\t1.本保单\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("不可减人"),
                      ]),
                      _vm._v("\n\t\t\t\t\t，可加人。\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("保单可换人，已出险人员不得批减、替换、退保。"),
                      ]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t2.如被保险人未有员工出险，\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "则保险人收取最低保费后，允许保单退保，并退还剩余保费。"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t最低保费标准：\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t截止被保险人书面提出退保申请之日，生效不超15天（含）的按照半个月保费收费，生效超过15天且不足一个月的按照一个月保费收费。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t3.在\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("工作时间和工作岗位，突发疾病死亡"),
                      ]),
                      _vm._v("\n\t\t\t\t\t或者\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("在48小时之内经抢救无效死亡"),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t（雇员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("赔付金额=每人身故赔偿限额*20%。"),
                      ]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t4.医疗费用如其他第三方先行赔付的，本保险医疗费用项下扩展自费药；\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "如医药费用无其他第三方先行赔付的，则本保单不予扩展赔付自费药。"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t5.被保险人雇员\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("仅接受门诊治疗的，无误工费赔付。"),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t6.\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t电梯安装、电梯维修保养过程中从事高处作业必须配带安全带、安全帽，孔洞须加强围栏或防滑措施。\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v("\n\t\t\t\t\t出险时\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t如未系绑安全带导致发生身故或伤残事故，保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t7.\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "电梯维保工人需持有电梯修理T证，电梯安装工人需要通过岗前培训通过证明文件"
                        ),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t，否则一旦发生保险事故，\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "保险人对按保单约定的应承担的保险责任，扣除绝对免赔25%后赔付。"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t8.\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "本保单被保险人应在保险事故发生后 48 小时内报案，"
                        ),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t如超出 48 小时报案导致保险人无法核实事故真实情况，则保险人有权拒赔。\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t如果被保险人超过72小时才报案，则保险人对按保单约定的应承担的保险责任，扣除绝对免赔50%后赔付。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t9.\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v("本保单不承担任何性质的精神损害赔偿责任。"),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人均已知悉")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 22
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "450px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "u-m-b-15 u-font-weight-bold" },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t以下是该保险产品中免除保险人责任或缩小保障的措辞，烦请投保人确认无误后，方可点击确定投保。\n\t\t\t\t\t"
                          ),
                        ]
                      ),
                      _vm._v(
                        "\n\t\t\t\t\t1、本保险承保雇员的职业范围：《职业分类表》中的1-5级职业等级（标注拒保的除外）；雇员是否涉高以保单中雇员清单信息约定为准。\n\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t2、发生保险事故后，被保险人应该在48小时内向保险人报案，对身故、伤残案件，能核实事故真实情况，\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "但报案超过案发时间72小时（含）以上的，按损失金额的50%免赔后进行赔付"
                        ),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t；对非身故、伤残的其他案件，能核实事故真实情况，\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "但报案超过案发时间1个月以上（含1个月）的，按损失金额的50%免赔后进行赔付。"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t3、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t如保单中约定雇员不涉高，出险时雇员从事高处作业，保险人不承担赔偿责任。如出险时被保险人的雇员工作类型所对应的职业属于本产品拒保职业的，保险人不承担赔偿责任，拒保职业清单详见保单。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t4、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t如出险时被保险人的雇员工作类型所对应的职业属于本产品拒保职业的，保险人不承担赔偿责任，拒保职业清单详见保单。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t5、本产品承保雇员以附件上传名单为准，\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t若本保单被保险人雇员实际职业类别高于保单人员清单列明职业类别的，保险人退还保险费，不承担保险责任。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("br"),
                      _vm._v(
                        "\n\t\t\t\t\t6、从事5类及以上特种作业岗位和高空岗位，按照国家规定须具有特种作业证和高空作业证，\n\t\t\t\t\t"
                      ),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "出险时如未能提供特种作业证和高空作业证，免赔率为80%。"
                        ),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t高处作业以《高处作业分级标准》(中华人民共和国国家标准GB3608-2008)中的定义为准(在距坠落高度基准面2m或2m以上有可能坠落的高处进行作业)。\n\t\t\t\t\t"
                      ),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t7、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t本保单承保被保险人雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡（既往症原因除外），本保单项下雇员赔偿限额不超过30万。既往症原因导致的猝死不属于本保单赔偿范围。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t8、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "对于雇员的挂床行为，保险人不承担住院津贴给付的保险责任。"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t9、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t保险期限1-3个月的保单不可减人和换人，已替换出的人员不允许再次替换或批增。已批减的人员不允许替换或再次批增。已出险人员（含已报案未理赔和已理赔）不可以被替换和批减。\n\t\t\t\t\t"
                        ),
                      ]),
                      _c("br"),
                      _vm._v("\n\t\t\t\t\t10、\n\t\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t本产品仅限在中国大陆注册的合法机构购买，实际注册或经营地址在以下地区的单位本产品不予承保：\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v(
                        "\n\t\t\t\t\t天津市，山东省招远市、禹城市、荣成市、德州市、临沂市，北京平谷区、怀柔区、密云区，河北省三河市、廊坊市、沧州市、秦皇岛市、青龙县，黑龙江省，辽宁省，吉林省，内蒙古自治区通辽市、赤峰市，河南信阳市，湖北省黄冈市、麻城市，江苏省常州市。\n\t\t\t\t\t"
                      ),
                      _c("br"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人均已知悉")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.insureType == 23
        ? [
            _c(
              "table",
              {
                staticStyle: { "border-color": "LightGray" },
                attrs: { border: "1", cellpadding: "10", width: "100%" },
              },
              [
                _c("tr", [
                  _c("td", [
                    _vm._v("\n\t\t\t\t\t投保要求：企业名称\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v("不含“装卸”、“搬运”。"),
                    ]),
                  ]),
                ]),
                _c("tr", [
                  _c("td", [
                    _vm._v("\n\t\t\t\t\t被保险人从业人员的年龄\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v("限16-65周岁，本方案每人限投1份，超过部分无效。"),
                    ]),
                  ]),
                ]),
                _c("tr", [
                  _c("td", [
                    _vm._v(
                      "\n\t\t\t\t\t鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。\n\t\t\t\t\t"
                    ),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t保单可批增人员（不足1个月的按1个月收费）；在保单生效后申请退保或批减在保人员的，可退保费为0。\n\t\t\t\t\t"
                      ),
                    ]),
                  ]),
                ]),
                _c("tr", [
                  _c("td", [
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t如从业人员驾驶无有效行驶证车辆或未持有合法有效驾驶证、酒驾或醉驾期间发生交通事故的，保险人不承担保险责任。\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t\t若在运输途中，发生货物掉落、倾斜等情况，司机及随车人员因整理货物、篷布等操作导致意外事故属于保单责任。\n\t\t\t\t"
                    ),
                  ]),
                ]),
                _c("tr", [
                  _c("td", [
                    _vm._v("\n\t\t\t\t\t被保险人从业人员\n\t\t\t\t\t"),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t从事高空（高处）作业时，必须按照国家相关安全管理规定（包括但不限于必须佩戴安全绳、安全带或者安装防护网等安全设施设备）执行；从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证），\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v(
                      "\n\t\t\t\t\t否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，\n\t\t\t\t\t"
                    ),
                    _c("span", { staticClass: "red-bold" }, [
                      _vm._v("免赔25%。"),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject("showHint")
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count == 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t已知悉，我已告知投/被保险人，并取得投/被保险人的同意\n\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.insureType == 29
        ? [
            _c(
              "div",
              {
                staticClass: "container",
                staticStyle: {
                  padding: "10px 0",
                  "max-height": "500px",
                  "overflow-y": "scroll",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { justify: "center", type: "flex" } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("div", { staticClass: "u-font-weight-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t尊敬的投保人：在您确认投保前请先仔细阅读《投保须知》、《保险条款》，阅读时请您特别注意条款中的保险责任、责任免除、投保人被保险人义务、保险金申请、保险合同解除等内容及产品方案中的特别约定。\n\t\t\t\t\t"
                          ),
                        ]),
                        _c("el-divider"),
                        _c(
                          "div",
                          { staticStyle: { "white-space": "pre-line" } },
                          [
                            _vm._v("\n\t\t\t\t\t\t1、每人\n\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("仅限投保一份，多投无效。"),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t2、本保单被保险人年龄范围18周岁-65周岁，外籍人士及港澳台人士不支持投保。 3、\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t被保险人职业类别：本保单仅承保《中国人民财产保险股份有限公司意外伤害保险职业分类表》中5-6类职业人员，其他职业类别人员不在本保险合同的投保范围。被保险人职业类别以出险时的行为状态确定，从事不可保职业的人员为本保险不可保对象，本公司不承担保险责任；非不可保职业人员但从事不可保职业相关活动时发生的事故也不属于保险责任范围。其中下列职业被保险人不予投保：石材加工制造、矿业、采石业、炸药业、危险化工行业、直升机飞行人、飞行训练人、楼宇拆除工人爆破工作人员、潜水工作人员、火药、炸药制造人员、有关高压电工作人员、石棉瓦工作人员、特技演员、驯兽师、空中飞人、走钢丝人员、动物园驯兽师、保镖、炸药处理警察、防爆警察、警校学生、拳击运动员、各类赛车手、跳伞、登山运动人员、现役军人、煤矿业、油矿业。\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t4、意外医疗费用补偿责任： （1）医院范围：\n\t\t\t\t\t\t本保单意外医疗相关保障指定就诊医院为中华人民共和国境内(不包括香港、澳门、台湾地区)二级(含)及以上医院，且应符合下列所有条件:1)拥有合法经营执照；2)设立的主要目的为向受伤者和患病者提供留院治疗和护理服务；3)有合格的医生和护士提供全日二十四小时的医疗和护理服务；4)非主要作为康复医院、诊所、护理、疗养、戒酒、戒毒或类似的医疗机构。\n\t\t\t\t\t\t但\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t不包括以下医院：1）北京市的平谷区、密云区、怀柔区所有医院；2）江苏省的徐州市、南通市、连云港市所有医院；3）天津市的滨海、静海地区所有医院；4）辽宁省的铁岭市所有医院、辽宁中医药大学附属第二医院、中国人民解放军第二0五医院、辽宁省中医医院、营口市所有医院；5）吉林省的长春市、四平市所有医院、吉林省中医医院、吉林通化市人民医院、抚松县中医院；6）黑龙江省佳木斯市富锦市中心医院、中医医院、鸡西市所有医院；7）河北省的青县、青龙县、东光县、三河市、承德市兴隆县、廊坊市固安县所有医院、邯郸市馆陶县人民医院、南皮县中医医院；8）河南省的信阳市、洛阳市、郑州市、开封市、新乡市、商丘市、焦作市、安阳市黄县所有医院、通许县中医院；9）山东省的禹城市、栖霞市、莱州市、德州禹城、潍坊市高密县的所有医院、滨州市中心医院、青岛市即墨区中医医院、莱阳市中医医院、济宁市金乡县人民医院、鱼台县人民医院、荣成市中医院、烟台市中医院、富顺县中医院、曹县人民医院、济南市长清区人民医院；10）山西省运城市、阳泉市所有医院、太原市迎泽区中医院；11）四川省的宜宾市、内江市、雅安市所有医院、邛崃市医疗中心医院；12）内蒙古的扎兰屯市、赤峰市所有医院；13）广东省的湛江市第二中医医院、茂名市电白区人民医院；14）湖南省的衡阳市中医正骨医院、衡阳市中心医院；15）安徽省毫州市所有医院；16）甘肃省民勤县人民医院、庆阳市中医医院；17）福建南平的所有医院；18）所有私营社保定点医院。请注意：被保险人在上述医院进行治疗的保险人均不予以理赔，建议您去其他区域的二级或二级以上医院就医。\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t（2）赔付标准：\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t在保险期间内，对于被保险人遭受意外伤害之日起实际支出的当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，在扣除社会基本医疗保险、公费医疗已经补偿或给付部分后，保险人按每次事故绝对免赔额100元，对其余额按80%比例给付；若被保险人未参加社会医疗保险身份就诊或结算的，对于事故发生之日起实际支出的按照当地(保单签发地)社会医疗保险主管部门规定可报销的、必要、合理的医疗费用，保险人扣除每次事故绝对免赔额300元后，对其余额按60%比例给付。保险期间届满被保险人治疗仍未结束的，保险人所负保险责任期限可按下列约定延长：门诊急诊治疗者，自保险期间届满次日起计算，以门诊急诊延长15日为限；保险期间届满被保险人仍在住院治疗的，自保险期间届满次日起计算，至出院之日止，最长以90日为限。\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t5、本产品意外伤害医疗保障，\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t不承担普通针刺治疗、针炙治疗、红外线治疗、可见光治疗、紫外线治疗、激光疗法、光敏疗法、直流电治疗、低频脉冲电治疗、中频脉冲电治疗、超短波短波治疗、微波治疗、射频电疗、静电治疗、空气负离子治疗、超声波治疗、电子生物反馈疗法、磁疗、水疗、蜡疗、泥疗、牵引、气压治疗、冷疗、电按摩、场效应治疗、中频脉冲电治疗、穴位贴敷治疗、中医定向透药疗法等中医治疗、理疗行为产生的医疗费用。\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t6、意外住院津贴责任：意外住院津贴责任100元/天，\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "单次最高给付津贴日数30天，总给付日数180天，免赔天数0天。"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t7、在本保单可承保高空作业，\n\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t被保险人若从事高处作业【凡在坠落高度基准面2m以上(含2m)有可能坠落的高处进行的作业，高处作业以《高处作业分级标准》(中华人民共和国国家标准GB/T3608-2008)中的定义为准】，须按照相关行业安全管理规定取得由应急管理部门颁发《高处作业操作证》，否则发生死亡或伤残事故，保险人按照保单约定应承担保险责任的\n\t\t\t\t\t\t\t75%计算赔偿金额。\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v("\n\t\t\t\t\t\t8、被保险人\n\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t如系涉及特种行业岗位，根据《中华人民共和国安全生产法》之规定，必须持有国家安全生产监管局签发的特种作业操作证（不含高处作业操作证），或国家质量技术监督局签发的特种设备作业证上岗，否则本保险公司对可能发生的人身伤亡及医疗费用不承担赔偿责任。\n\t\t\t\t\t\t"
                              ),
                            ]),
                            _c("el-divider"),
                            _c("span", { staticClass: "u-font-weight-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t1、本人已完整阅读并了解以上《投保须知》、《保险条款》等相关说明，尤其是对其中免除保险人责任的条款或约定（包括但不限于保险责任、责任免除、投保人被保险人义务、保险金申请、保险合同解除等），本人已充分理解并接受上述内容，同意以此作为订立保险合同的依据；\n\t\t\t\t\t\t\t2、当被保险人非本人时,本人确认已告知被保险人或其监护人本产品的相关内容,并已征得其同意投保本产品；\n\t\t\t\t\t\t\t3、投保单中所填写的内容均属实，如有隐瞒或不实告知，保险公司有权根据《中华人民共和国保险法》第十六条的规定解除保险合同，对于合同解除前发生的任何事故，保险公司可不承担任何责任。\n\t\t\t\t\t\t"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.onReject()
                      },
                    },
                  },
                  [_vm._v("谢谢，投/被保险人不同意此告知")]
                ),
                _vm.count > 0
                  ? _c(
                      "el-button",
                      { attrs: { disabled: true, type: "primary" } },
                      [_vm._v(_vm._s(_vm.count) + "s后可关闭")]
                    )
                  : _vm._e(),
                _vm.count === 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onAgree },
                      },
                      [_vm._v("投/被保险人均已知悉")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }